import useOneTimeExecution from "@/utils/hooks/useOneTimeExecution";
import React, { useState } from "react";
import styles from "./index.module.less";

interface UseUserGuideProps {
  guideKey: string;
  imageUrl: string;
  enabled?: boolean;
}

/**
 * @description 控制一次性用户指引的 Hook，并返回一个可以直接渲染的组件和手动触发函数。
 * @param {UseUserGuideProps} props - 包含 guideKey, imageUrl, 和 enabled 状态。
 * @returns {{ GuideComponent: React.FC; showGuide: () => Promise<void> }}
 */
const useUserGuide = ({ guideKey, imageUrl, enabled = true }: UseUserGuideProps) => {
  const [isGuideVisible, setIsGuideVisible] = useState(false);

  const showGuideCallback = () => {
    setIsGuideVisible(true);
  };

  const hideGuide = () => {
    setIsGuideVisible(false);
  };

  // 从 useOneTimeExecution 获取手动触发函数
  const [triggerGuide] = useOneTimeExecution(guideKey, showGuideCallback, enabled);

  const GuideComponent: React.FC = () => {
    if (!isGuideVisible || !imageUrl) {
      return null;
    }

    return (
      <div className={styles.guideOverlay} onClick={hideGuide}>
        <img className={styles.guideImage} src={imageUrl} alt="用户指引" />
      </div>
    );
  };

  return { GuideComponent, showGuide: triggerGuide };
};

export default useUserGuide;
